<template>
  <div class="miao" style="padding-top:0px">

    <li v-for="(s, index) in seckillList" :key="index">
      <span @click="detal(s.goods_id)">
        <img v-lazy="s.imgurl" alt />
        <img src="../../assets/images/mi.png" alt />
      </span>
      <span>
        <p @click="detal(s.goods_id)">{{ s.goods_name }}</p>

        <p>
          <span><span>
              ￥ <span>{{ s.goods_price | toint }}</span></span>
            <span>￥{{ s.line_price | toint }}</span></span>
          <span @click="detalmiao(s.goods_id)">去抢购</span>

        </p>
      </span>
    </li>

  </div>
</template>
<script>
var moment = require("moment");
import { Toast } from "vant";
export default {
  data() {
    return {
      timeData: {
        minutes: "",
        seconds: "",
        hours: "",
      },
      ske: true,
      seckillList: [],
      remainH: "",
      remainM: "",
      remainS: "",
      killselected: 0,
    };
  },
  created() {
    this.miaoData();
  },
  filters: {
    toint(value) {
      return parseInt(value);
    },
  },
  methods: {
    setItemText(e) {
      return "已抢" + e + "%";
    },
    setItemProgress(e) {
      if (e == null || e == undefined) {
        return 0;
      } else {
        return e;
      }
    },
    backHome() {
      this.$router.push({ name: "HomeIndex" });
    },
    detalmiao(e) {
      this.$router.push({
        name: "Ta",
        query: { id: e },
        params: { dlip: "miao" },
      });
    },
    detal(id) {
      this.$router.push({
        name: "Ta",
        query: { id: id },
      });
    },
    finish() {
      Toast("本时段抢购已结束");
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    },
    miaoData() {

      this.$api.post(this.$api.base, "/wxapi/seckill/list", { wxapp_id: localStorage.getItem("mid") }, (r) => {
        if (r.data.status == 200) {
          this.seckillList = r.data.data;
        }
      });
    },
  },
};
</script>
<style  lang="scss" scoped>
@import "../../scss/home";

.van-notice-bar {
  background: white;
  // color:#ce9a79 !important;
  color: #ecc160 !important;
  font-size: 0.13rem;
}
</style>